export const test = (state, data) => {
    state.test = data;
};
